import classNames from "classnames";
import Avatar from "components/base/Avatar";
import Scrollbar from "components/base/Scrollbar";
import { useState } from "react";
import { Card, Dropdown, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import ChangePasswordModal from "components/modals/ChangePasswordModal";
import ImpersonateModal from "components/modals/ImpersonateModal";
import { useLogout, useUser } from "services/account";
import Icon from "components/common/Icon";

const ProfileDropdownMenu = ({ className }: { className?: string }) => {
  const { user } = useUser();
  const { mutateAsync: logout } = useLogout();

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showImpersonateModal, setShowImpersonateModal] = useState(false);

  // Verificar se o usuário é admin
  const isAdmin = user?.roles?.includes("admin");
  const isRevenda = user?.roles?.includes("cadastro");

  const [navItems] = useState([
    // {
    //   label: "Perfil",
    //   icon: "user",
    // },
    {
      label: "Alterar senha",
      icon: "lock",
      onClick: () => setShowChangePasswordModal(true),
    },
    {
      show: (isAdmin || isRevenda) && !user?.impersonating,
      label: "Personificar Usuário",
      icon: "user-plus",
      onClick: () => setShowImpersonateModal(true),
    },
    // {
    //   label: "Central de Ajuda",
    //   icon: "help-circle",
    // },
  ]);

  return (
    <>
      <Dropdown.Menu
        align="end"
        className={classNames(
          className,
          "navbar-top-dropdown-menu navbar-dropdown-caret py-0 dropdown-profile shadow border"
        )}
      >
        <Card className="position-relative border-0">
          <Card.Body className="p-0">
            <div className="d-flex flex-column align-items-center justify-content-center gap-2 pt-4 pb-3">
              {user?.imageUrl ? (
                <Avatar variant="image" src={user.imageUrl} size="xl">
                  {user?.nome?.charAt(0)}
                </Avatar>
              ) : (
                <Avatar variant="name" size="xl">
                  {user?.nome?.charAt(0)}
                </Avatar>
              )}
              <h6 className="text-body-emphasis">{user?.nome}</h6>
            </div>
            <div style={{ height: "10rem" }}>
              <Scrollbar>
                <Nav className="nav flex-column mb-2 pb-1">
                  {navItems
                    .filter((item) => item.show !== false)
                    .map((item) => (
                      <Nav.Item key={item.label}>
                        <Nav.Link
                          href="#!"
                          className="px-3"
                          onClick={item.onClick}
                        >
                          <Icon iconName={item.icon as any} size={16} className="me-2 text-body" />
                          <span className="text-body-highlight">
                            {item.label}
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                </Nav>
              </Scrollbar>
            </div>
          </Card.Body>
          <Card.Footer className="p-0 border-top border-translucent">
            <div className="px-3">
              <Link
                onClick={async () => await logout()}
                className="btn btn-phoenix-secondary d-flex flex-center w-100"
                to={"/pages/authentication/simple/sign-in"}
              >
                <Icon iconName={"log-out" as any} className="me-2" size={16} />
                Sair
              </Link>
            </div>
            <div className="my-2 text-center fw-bold fs-10 text-body-quaternary">
              <Link
                className="text-body-quaternary me-1"
                to="https://wisenpharma.com.br/politica-de-privacidade/"
                target="_blank"
              >
                Política de Privacidade
              </Link>
              •
              <Link className="text-body-quaternary mx-1" to="#!">
                Termos de Serviço
              </Link>
              •
              <Link className="text-body-quaternary ms-1" to="#!">
                Cookies
              </Link>
            </div>
          </Card.Footer>
        </Card>
      </Dropdown.Menu>

      {/* Modal de Alteração de Senha */}
      {showChangePasswordModal && (
        <ChangePasswordModal
          show={showChangePasswordModal}
          onHide={() => setShowChangePasswordModal(false)}
        />
      )}

      {/* Modal de Personificação de Usuário */}
      {showImpersonateModal && (
        <ImpersonateModal
          show={showImpersonateModal}
          onHide={() => setShowImpersonateModal(false)}
        />
      )}
    </>
  );
};

export default ProfileDropdownMenu;
